import React from 'react';
import { Row, Col, Badge } from 'reactstrap';
import IntlMessage from '../../../helpers/intlMessage';

function TemplateHtmlItemKanban (lamina, imprimirEtiquetaIndividual) {
  return (
    <Row style={{ marginTop: '16px' }}>
      <Col xs={10} style={{ marginTop: '-10px' }}>
        <p style={{ fontSize: '16px', fontWeight: 600, marginBottom: '2px' }}>
          {lamina.dsCasoLamina}
        </p>
        <p style={{ fontSize: '14px', marginBottom: 0 }}>
          <strong><IntlMessage id = "dashboards.taskControl.block"/>: </strong>
          {lamina.nrBloco}
        </p>
        <p style={{ fontSize: '14px', marginBottom: '0px' }}>
          <strong><IntlMessage id = "dashboards.reports.doctor"/>: </strong>
          {lamina.nome}
        </p>
        <p style={{ fontSize: '14px', marginBottom: '0px' }}>
          <strong><IntlMessage id = "dashboards.examDetail.patient"/> </strong>
          {lamina.nomePaciente}
        </p>
        {lamina.pacienteNomeSocial && (<p style={{ fontSize: '14px', marginBottom: '0px' }}>
          <strong><IntlMessage id = "dashboards.examDetails.socialName"/> </strong>
          {lamina.pacienteNomeSocial}
        </p>)}
        <p style={{ fontSize: '14px', marginBottom: 0 }}>
          <strong><IntlMessage id = "dashboards.taskControl.antibody"/>: </strong>
          <Badge color='primary' className='badge-reagente'>
            <Badge color='link'>{lamina.anticorpo}</Badge>
            <Badge color='dark'>{lamina.tipo}</Badge>
          </Badge>
        </p>
      </Col>
      <Col xs={2}>
        <p
          style={{ position: 'absolute', right: '19px', fontSize: '10px' }}
          className='badge badge-info'
        >
          {lamina.dataAtualizacao}
        </p>
        <Row>
          {(lamina.existeNConformidade === 0 ||
            lamina.existeNConformidade === 1) && (
            <p className='badge badge-danger nao-conformidade'>
             <IntlMessage id='dashboards.general.nonCompliance' />
            </p>
          )}
          <div className='menu-card' style={{ right: '-30px' }}>
            <i
              style={{ marginRight: '8px' }}
              className='mv-basico-codigo_barras'
              onClick={() => {
                imprimirEtiquetaIndividual(lamina);
              }}
            ></i>
          </div>
        </Row>
      </Col>
    </Row>
  );
}

export default TemplateHtmlItemKanban;



// WEBPACK FOOTER //
// ./src/pages/histologia/common/templateHtmlItemKanban.js